module.exports = __webpack_public_path__ + "945f55354dd2302273b67d84862c3d64.svg";